export default __webpack_public_path__ + "static/media/Group1624@2x.9e32632a.png";